// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';
// Translations
import { ERROR_MODAL_CONTENT, ERROR_MODAL_TITLE } from '../translations/error-modal.translations';

const ERROR_MODAL_COMPONENT_PROPS = {
  description: ERROR_MODAL_CONTENT,
  id: ModalReferencesEnumeration.ERROR_CANCEL_PROCESS,
  title: ERROR_MODAL_TITLE,
};

export { ERROR_MODAL_COMPONENT_PROPS };
